// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_BGb","cls2":"AuthorHeader-cls2__e2 AuthorHeader-cls1_BGb"};